import { Button } from "@/components/ui/button";
import { Check, X } from "lucide-react";
import {
  useGetIdentity,
  useGetList,
  useNotify,
  useRecordContext,
  useRefresh,
  useUpdate,
} from "ra-core";
import { useHasPermission } from "../../rbac/useHasPermission";

export const LeaveApprovalActions = () => {
  const record = useRecordContext();
  const notify = useNotify();
  const refresh = useRefresh();
  const { data: identity } = useGetIdentity();
  const { hasPermission, isLoading } = useHasPermission("approve_leave");
  const [update, { isPending }] = useUpdate();

  const { data: employeeRecords } = useGetList("employees", {
    filter: { "sales_id@eq": identity?.id },
    pagination: { page: 1, perPage: 1 },
  });
  const currentEmployeeId = employeeRecords?.[0]?.id ?? null;

  if (!record || record.status !== "pending" || isLoading || !hasPermission)
    return null;

  const setStatus = (status: "approved" | "rejected") => {
    update(
      "hr_leave_requests",
      {
        id: record.id,
        data: {
          status,
          approver_id: currentEmployeeId,
          approved_at: new Date().toISOString(),
        },
        previousData: record,
      },
      {
        onSuccess: () => {
          notify(`Leave request ${status}`);
          refresh();
        },
        onError: (error: any) =>
          notify(error?.message || "Could not update leave request", {
            type: "error",
          }),
      },
    );
  };

  return (
    <div className="flex items-center gap-2">
      <Button
        size="sm"
        onClick={() => setStatus("approved")}
        disabled={isPending}
        className="gap-2"
      >
        <Check className="h-4 w-4" />
        Approve
      </Button>
      <Button
        size="sm"
        variant="outline"
        onClick={() => setStatus("rejected")}
        disabled={isPending}
        className="gap-2"
      >
        <X className="h-4 w-4" />
        Reject
      </Button>
    </div>
  );
};
